import { AnyObject } from "global";
import React from "react";
import CurrencyCode from "shared/enums/CurrencyCode";
import { ApiApplicableRateCardDetails } from "shared/types/ApiApplicableRateCardDetails";
import OrganizationStatus from "shared/enums/OrganizationStatus";
import { OrganizationEditService } from "../components/organizationName/type";

export interface DynamicFormRendererCustomDataType {
  organizationId?: string;
  registrationFormId?: string;
  registrationId?: string;
  eventSeriesId?: string;
  participantId?: string;
  orgChangeHandler?: (orgId: string, organization?: AnyObject) => void;
  isAdminOnly?: boolean;
  children?: React.ReactNode;
  organizationStatus?: OrganizationStatus;
  isRegistrationOrganization?: boolean;
  applicableRates?: Array<ApiApplicableRateCardDetails>;
  currencyCode?: CurrencyCode;
  localeId?: string;
  registrationParticipantId?: string;
  programParticipantId?: string;
  organizationEditService?: OrganizationEditService;
  validateEmailDomain?: boolean;
  invalidEmailDomainErrorMessage?: string;
  useCheckBoxFullWidthViewFromApi?: boolean;
  isAITextEnhancementEnabled?: boolean;
  eventId?: string;
}

const DynamicFormRendererContext = React.createContext<DynamicFormRendererCustomDataType>({});

function DynamicFormRendererProvider(props: DynamicFormRendererCustomDataType) {
  return <DynamicFormRendererContext.Provider value={props}>{props.children}</DynamicFormRendererContext.Provider>;
}

function useDynamicFormRenderer() {
  const context = React.useContext(DynamicFormRendererContext);
  if (context === undefined) {
    throw new Error(`useDynamicFormRenderer must be used within a DynamicFormRendererProvider`);
  }
  return context;
}

export { useDynamicFormRenderer, DynamicFormRendererProvider };
